import { Skeleton } from '@parcel/ui';

export function FeedSkeleton() {
  return (
    <ol aria-label="Loading the News feed" className="overflow-hidden rounded-xl border">
      {Array.from({ length: 6 }, (_, index) => (
        <li
          // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder rows
          key={index}
          className="flex items-center gap-3 border-b px-4 py-4 last:border-b-0"
        >
          <Skeleton className="size-9 rounded-lg" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-3.5 w-1/3" />
            <Skeleton className="h-3 w-2/3" />
          </div>
        </li>
      ))}
    </ol>
  );
}
